import { createAsyncStorageAPI } from './createAsyncStorageAPI';
import { createStorageFallback } from './createStorageFallback';

const DEFAULT_MAXIMUM_BYTE_SIZE = 102400;
const getStorage = (_window: Window = window) =>
    _window?.navigator?.cookieEnabled
        ? _window.localStorage
        : createStorageFallback();

/**
 * Module that handles logic around local storage, implementing a localstorage fallback where necessary.
 */
export const createStorageModule = (
    /**
     * Window object on DOM
     */
    _window: Window,
    /**
     * Number sourced from config
     */
    maximumByteSizeOfAnItem = DEFAULT_MAXIMUM_BYTE_SIZE,
) => {
    const storageImpl = getStorage(_window);
    return createAsyncStorageAPI(storageImpl, maximumByteSizeOfAnItem);
};
